module.exports = new __parcel__URL__("second_tab_content_zh-cn.486395a8.webp").toString();